import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';
import amber from '@material-ui/core/colors/amber';
import { withStyles } from '@material-ui/core/styles';

function DevelopMentSnackbar(props) {
  const { classes, className, message, variant, ...other } = props;
  const Icon = WarningIcon;

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      {...other}
    />
  );
}

DevelopMentSnackbar.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  message: PropTypes.node,
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired,
};

const styles1 = theme => ({
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});

function EnvModeSnackBar() {
  const SnackbarContentWrapper = withStyles(styles1)(DevelopMentSnackbar);
  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      // development または hostnameがlocalhostの場合のみ表示
      open={
        process.env.REACT_APP_ENV === 'development' ||
        window.location.hostname === 'localhost'
      }
    >
      <SnackbarContentWrapper
        variant="warning"
        className={'warning'}
        message={`${process.env.REACT_APP_ENV.toUpperCase()} Mode`}
      />
    </Snackbar>
  );
}

export default EnvModeSnackBar;



// WEBPACK FOOTER //
// ./src/views/components/envModeSnackBar/index.js